import React from 'react'
import Link from "next/link";
import Image from 'next/image'
import menu_white from '../../public/assets/images/menu_white.svg'
import menu from '../../public/assets/images/menu.svg'
import {modular} from "../../util/constants";

const Header = ({showSidebar, setShowSidebar}) => {
    return (
        <>
            <div id='header' className={"header-container"}>
                <div className="container-top">
                    <div>
                        <div className="left">
                            <Link href={"/"}>
                                <div className="logo">
                                    <Image src={modular.logo} alt=''/>
                                </div>
                            </Link>
                        </div>
                        <div className="right">
                            <button className='menu-icon' onClick={() => {
                                setShowSidebar(!showSidebar)
                            }}>
                                <Image src={modular.mobileMenuButtonColor ? menu : menu_white} height={35} width={35}/>
                            </button>
                            {modular.headerButton &&
                                <Link href={modular.headerButton.link}>
                                    <div className={"button-outline"}>
                                        {modular.headerButton.text}
                                    </div>
                                </Link>}
                        </div>
                    </div>
                </div>
            </div>
            <div className="header-placeholder"/>
        </>
    )
}

export default Header
